module.exports = __webpack_public_path__ + "img/character_civil.5424dd59.svg";